/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseCampaignDetailsDto } from '../../models/recourse-campaign-details-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SaveResourceCampaignDetails$Params {
  recourseCampaignId: string;
  body: RecourseCampaignDetailsDto;
}

export function saveResourceCampaignDetails(
  http: HttpClient,
  rootUrl: string,
  params: SaveResourceCampaignDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecourseCampaignDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, saveResourceCampaignDetails.PATH, 'put');
  if (params) {
    rb.path('recourseCampaignId', params.recourseCampaignId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecourseCampaignDetailsDto>;
    }),
  );
}

saveResourceCampaignDetails.PATH = '/service/v1/recourseCampaign/recourseCampaignDetails/{recourseCampaignId}';
